import { eachDayOfInterval, addDays } from 'date-fns'

type IterateDays = (
  targetDate: Date,
  numberOfDays: number,
  callback: (date: Date, index: number) => JSX.Element
) => JSX.Element[]

export const iterateDays: IterateDays = (targetDate, numberOfDays, callback) =>
  eachDayOfInterval({
    start: targetDate,
    end: addDays(targetDate, numberOfDays - 1),
  }).map(callback)
